import { BrowserRouter as Router } from "react-router-dom";
import CssBaseline from "@material-ui/core/CssBaseline";
import React from 'react';
import { useAuth } from "./context/AuthContext";
import { observer } from "mobx-react"
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { AppMenu } from './components/Menu';
import { Auth } from './pages/auth/auth';
import GlobalStyles from '@mui/material/GlobalStyles'
import { getStore } from './Store'
const store = getStore();

const theme = createTheme({
  palette: {
    type: 'light',
    primary: {
      main: '#32a852',
    },
    secondary: {
      main: '#F04005',
    },
  },
  typography: {
    fontFamily: 'Open Sans',
    h1: {
        fontFamily: 'Michroma',
    },
    h2: {
      fontFamily: 'Michroma',
    },
    h3: {
      fontFamily: 'Michroma',
    },
    h4: {
      fontFamily: 'Michroma',
    },
    h5: {
        fontFamily: 'Michroma',
    },
    h6: {
      fontFamily: 'Michroma',
    },
  },
});

const themeDark = createTheme({
    palette: {
        type: 'light',
        primary: {
            main: '#32a852',
        },
        secondary: {
            main: '#F04005',
        },
        background: {
            default: "#1E2831"
        },
        text: {
            primary: "#ffffff"
        },
    },
  typography: {
        fontFamily: 'Open Sans',
        h1: {
            fontFamily: 'Michroma',
        },
        h2: {
            fontFamily: 'Michroma',
        },
        h3: {
            fontFamily: 'Michroma',
        },
        h4: {
            fontFamily: 'Michroma',
        },
        h5: {
            fontFamily: 'Michroma',
        },
        h6: {
            fontFamily: 'Michroma',
      },
    },
});

const App = observer(() => {
    const [dark, setDark] = React.useState(false);

    const { user } = useAuth();

    if (!user) {
        return (<Auth />)
    }

    else {
        return (
            <ThemeProvider theme={dark ? themeDark: theme} >
                <GlobalStyles styles={{ 'svg path': { color: '#32a852' } }} />
                <CssBaseline />
                <Router>
                    <AppMenu theme={dark ? themeDark : theme} dark={dark} setDark={setDark} />
                 </Router>
          </ThemeProvider>
        )
    }
    
})

export default App;
